export type ManageTabId = 'overview' | 'content' | 'evaluation' | 'people';

export interface ManageTab {
  id: ManageTabId;
  label: string;
  description: string;
}

export const MANAGE_TABS: ManageTab[] = [
  { id: 'overview', label: 'Overview', description: 'Key numbers and shortcuts' },
  { id: 'content', label: 'Content', description: 'Title, description, logo and instructions' },
  { id: 'evaluation', label: 'Evaluation', description: 'Settings, rubric, results and auto-evaluation' },
  { id: 'people', label: 'People', description: 'Access, hosts, teams and notifications' },
];
